<template>
  <transition appear @enter="onEnter" @leave="onLeave">
    <section class="country_selector" v-if="showCountrySelector">
      <div class="inner" ref="inner">
        <paragraph-header size="4"><span v-html="$t('Please confirm your location:')"></span></paragraph-header>
        <div class="selector">
          <button
            type="button"
            v-for="country in countryList"
            :key="country.value"
            @click="onSelect(country.value)"
            :class="{ is_active: shippingCountry === country.value, country_button: true }"
          >
            <svg class="flag" width="14" height="14" viewbox="0 0 14 14">
              <use v-bind:xlink:href="`#${country.flag}`"></use>
            </svg>
            <span>{{ $t(country.label) }}</span>

            <span class="arrow"></span>
          </button>
        </div>
        <button type="button" class="country_selector_close" @click="showDialog = false">
          <span></span>
          <span></span>
        </button>
      </div>
      <div class="bg" ref="bg"></div>
    </section>
  </transition>
</template>

<script>
import ParagraphHeader from './atoms/ParagraphHeader.vue'
import Storage from '../helpers/localStorage'
import gsap from 'gsap'

export default {
  components: { ParagraphHeader },
  // components: { CustomSelector },
  data() {
    return {
      countryList: [
        { value: 'CH', label: 'Switzerland', flag: 'flag-ch' },
        { value: 'DE', label: 'Germany', flag: 'flag-de' },
        { value: 'AT', label: 'Austria', flag: 'flag-at' },
        { value: 'LI', label: 'Liechtenstein', flag: 'flag-li' },
      ],
      country: false,
      showDialog: false,
    }
  },
  created() {
    this.country = Storage.getCountry()
    if (this.country) {
      this.$store.commit('user/setShippingCountry', this.country)
    }
  },
  methods: {
    onSelect(value) {
      this.country = value
      this.showDialog = false
      this.$store.commit('user/setShippingCountry', value)
      Storage.setCountry(value)
    },
    open() {
      this.showDialog = true
    },
    onEnter(el, done) {
      const innerTransform = window.innerWidth < 1024 ? { y: '-130%', duration: 0.5 } : { x: '100%', duration: 0.5 }
      gsap
        .timeline({ onComplete: () => done() })
        .fromTo(this.$refs.bg, { opacity: 0 }, { opacity: 1, duration: 0.6 })
        .from(this.$refs.inner, innerTransform, '<0.2')
    },
    onLeave(el, done) {
      const innerTransform = window.innerWidth < 1024 ? { y: '-130%', duration: 0.3 } : { x: '100%', duration: 0.3 }
      gsap
        .timeline({ onComplete: () => done() })
        .to(this.$refs.inner, innerTransform)
        .to(this.$refs.bg, { opacity: 0, duration: 0.3 })
    },
  },
  computed: {
    showCountrySelector() {
      return !this.country || this.showDialog
    },
    shippingCountry() {
      return this.$store.state.user.shippingCountry
    },
  },
}
</script>

<style lang="scss" scoped>
.country_selector {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(2px);
    z-index: 3;
    background-color: rgba($colorBeige, 0.75);
  }
}

.inner {
  position: absolute;
  background: $colorWhite;

  @include mq($to: tabletWide) {
    top: 10px;
    right: 10px;
    width: calc(100% - 20px);
    max-width: 400px;

    padding: 24px 15px 14px 25px;
    z-index: 4;
    border-radius: 28px;

    box-shadow: 0 22px 20px 0 rgba(121, 107, 57, 0.2);
  }

  @include mq($from: tablet) {
    right: calc(7.5% - 10px);
  }

  @include mq($from: tabletWide) {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 460px;
    max-width: 100%;
    padding: 70px 100px;
    z-index: 4;
  }
}

button.country_button {
  @include resetButton();
  display: flex;
  padding: 5px 0;
  position: relative;
  cursor: pointer;
  align-items: center;

  &.is_active,
  &:hover {
    .arrow {
      opacity: 1;
    }
  }

  .flag {
    margin-right: 8px;
  }

  .arrow {
    position: absolute;
    left: -8px;
    top: calc(50% - 14px);

    width: calc(100% + 26px);
    height: 28px;

    border-radius: 14px;

    opacity: 0;
    transition: opacity 0.3s;
    background: $colorBeigeDark;
    z-index: -1;
  }
}

button.country_selector_close {
  position: absolute;
  top: 10px;
  right: 10px;

  display: inline-block;
  width: 32px;
  height: 32px;
  background: $colorWhite;
  border-radius: 50%;
  border: 1px solid $colorBlack;
  transition: background-color 0.3s;
  cursor: pointer;
  transition: all 0.3s;

  @include mq($from: tabletWide) {
    top: 20px;
    right: 20px;
  }

  span {
    display: block;
    width: 16px;
    height: 2px;
    background: $colorBlack;

    position: absolute;
    top: 14px;
    left: 7px;

    &:nth-child(1) {
      transform: rotate(45deg);
    }

    &:nth-child(2) {
      transform: rotate(-45deg);
    }
  }

  &:hover {
    filter: invert(1);
  }
}

.selector {
  margin-top: 25px;
}
</style>
